// extracted by mini-css-extract-plugin
export default {"section":"ResetPassword_section__lUqaT","background":"ResetPassword_background__2k4TZ","logo":"ResetPassword_logo__-1AFX"};